import type { SetupDraft } from '@/types/setup-wizard.types';

export const DRAFT_STEP_TOTAL = 5;

/** Wizard hash for a draft's saved step — `people` is routed under `#import`. */
export function draftStepHash(draft: SetupDraft): string {
  return draft.currentStep === 'people' ? 'import' : draft.currentStep || 'guide';
}

export function draftTitle(draft: SetupDraft): string {
  return draft.companyDraft?.name?.trim() || 'Untitled company';
}

/** Deep link that reopens the wizard on the step the draft was left at. */
export function draftSetupPath(draft: SetupDraft): string {
  return `/companies/setup-wizard/drafts/${draft._id}#${draftStepHash(draft)}`;
}

/** Most recently touched draft first, so "resume" always means the last one worked on. */
export function sortDraftsByRecency(drafts: SetupDraft[]): SetupDraft[] {
  return [...drafts].sort((a, b) => {
    const left = a.updatedAt ?? a.createdAt ?? '';
    const right = b.updatedAt ?? b.createdAt ?? '';
    return right.localeCompare(left);
  });
}
